export type UpscopeEnv = "production" | "staging";

export function upscopeURL(upscopeEnv: UpscopeEnv): string {
  if (upscopeEnv === "production") return "https://integrations.userview.com";

  if (upscopeEnv === "staging") return "https://integrations.userview.xyz";

  return "http://integrations.userview.local";
}
